import { cn } from "@gymflow/helpers";
import { SubscriptionSessionPackUsageHistoryDTO } from "@gymflow/types";
import { Coins03Icon } from "apps/portal/src/components/atoms/icons/Coins03Icon";
import { useClubSettings } from "apps/portal/src/providers";
import moment from "moment";

import { DATE_ONLY_FORMAT, USAGE_TIME_FORMAT } from "../../constants";
import { UsageItemStatus } from "./components/UsageItemStatus";

export type UsageItemType = SubscriptionSessionPackUsageHistoryDTO;

type UsageItemProps = {
  usageInfo: UsageItemType;
  last: boolean;
};

export const UsageItem = ({
  last,
  usageInfo: { startDate, name, sessionsUsed, status },
}: UsageItemProps) => {
  const { timezone } = useClubSettings();

  const date = moment(startDate).tz(timezone);

  return (
    <div className="flex flex-row gap-2.5">
      <div className="flex flex-col items-center gap-1 px-1 pt-1">
        <div className="h-3 w-3 rounded-full bg-gray-300" />
        <div className="w-px flex-1 rounded-full bg-gray-300" />
      </div>
      <div
        className={cn("flex flex-col gap-2 flex-1", {
          "mb-6": last,
        })}
      >
        <div className="flex flex-row items-center gap-1.5 text-sm font-semibold text-gray-500">
          {date.format(DATE_ONLY_FORMAT).toLocaleString()}
          <div className="h-1.5 w-1.5 rounded-full bg-gray-300" />
          {date.format(USAGE_TIME_FORMAT).toLocaleString()}
        </div>
        <div className="flex flex-row items-center justify-between rounded-xl border border-gray-200 p-3">
          <div className="flex flex-col gap-1">
            <div className="text-sm font-semibold text-gray-950">{name}</div>
            <UsageItemStatus status={status} />
          </div>
          <div className="flex items-center justify-between gap-1">
            <div className="text-lg font-bold text-gray-950">
              -{sessionsUsed}
            </div>
            <Coins03Icon className="h-5 w-5" />
          </div>
        </div>
      </div>
    </div>
  );
};
